import Splide from "@splidejs/splide";

function initSliderAlumni(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-alumni").forEach((el) => {
		const splideAlumni = new Splide(el, {
			perPage: 2,
			gap: "22px",
			pagination: true,
			arrows: true,
			drag: "free",
			snap: true,
			focus: "left",
			autoplay: false,
			speed: 700,
			focus: 0,
			pauseOnHover: true,
			omitEnd: true,
			breakpoints: {
				991: {
					perPage: 1.5,
					gap: "30px",
				},
				768: {
					perPage: 1.1,
					padding: { right: "17%", left: 0 },
					gap: "16px",
				},
			},
		});

		splideAlumni.on("overflow", function (isOverflow) {
			splideAlumni.options = {
				arrows: isOverflow,
				pagination: isOverflow,
				drag: isOverflow,
			};
		});

		splideAlumni.mount();
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderAlumni());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-alumni", ($block) => {
		initSliderAlumni($block && $block.jquery ? $block.get(0) : $block);
	});
}
